import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0,1694.23529 L1920,1694.23529 L1920,226 L0,226 L0,1694.23529 Z M112.941176,376.663529 L112.941176,338.941176 L1807.05882,338.941176 L1807.05882,376.663529 L960,1111.23294 L112.941176,376.663529 Z M1807.05882,526.197647 L1807.05882,1476.71059 L1455.92471,1037.82118 L1367.60471,1108.29647 L1745.95765,1581.29412 L174.042353,1581.29412 L552.395294,1108.29647 L464.075294,1037.82118 L112.941176,1476.71059 L112.941176,526.197647 L960,1260.76706 L1807.05882,526.197647 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconEmailLine = /*#__PURE__*/function (_Component) {
  _inherits(IconEmailLine, _Component);

  var _super = _createSuper(IconEmailLine);

  function IconEmailLine() {
    _classCallCheck(this, IconEmailLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconEmailLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconEmail",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconEmailLine.displayName = "IconEmailLine";
  return IconEmailLine;
}(Component);

IconEmailLine.glyphName = 'email';
IconEmailLine.variant = 'Line';
IconEmailLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconEmailLine;
export { IconEmailLine };